// extracted by mini-css-extract-plugin
export default {"root":"Header_root__HuXU7","action":"Header_action__CbTIm"};